<script setup>
import TagsForm from './TagsForm.vue'

// --- Props ---
defineProps({
    options: {
        type: Object,
        required: true
    }
})

// --- Emits ---
const emit = defineEmits(['hide-modal'])
</script>

<template>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Tags</h4>

                <button type="button" class="btn-close" @click="emit('hide-modal')" aria-label="Close"></button>
            </div>

            <div class="modal-body">
                <TagsForm :id="options.id" :table-name="options.tableName"/>
            </div>

            <div class="modal-footer"></div>
        </div>
    </div>
</template>